module.exports = __webpack_public_path__ + "img/no_student_webinar.87c7d450.png";